import { gql } from '@apollo/client'

import {
  SIMPLE_ENTITY_FRAGMENT,
  USER_FRAGMENT,
} from '../../../common/graphql/fragments'

const USER_AND_TOKENS_FRAGMENT = gql`
  fragment UserAndTokensFragment on UserAndTokens {
    user {
      ...UserFragment

      roles {
        ...SimpleEntityFragment
      }

      settings {
        pageSize
      }
    }
    permissions
    accessToken
    refreshToken
  }
  ${USER_FRAGMENT}
  ${SIMPLE_ENTITY_FRAGMENT}
`

export default USER_AND_TOKENS_FRAGMENT
